// Shared query-key infrastructure for entity query hooks.
//
// TanStack Query expects readonly array keys. Centralising the entity
// roots here keeps cache invalidation predictable across the entity
// slices (agent, user, thread) that all share the same root namespace.
//
// Junior-friendly rules:
//   - One root per entity.
//   - Sub-keys are appended through the entity's own keys file.
//   - Never call useQuery with an inline string key in the rewrite code.

export type QueryKey = readonly unknown[];

export const queryRoots = {
  agents: 'agents',
  schedules: 'schedules',
  users: 'users',
  threads: 'threads',
  plugins: 'plugins',
} as const;

export type QueryRoot = (typeof queryRoots)[keyof typeof queryRoots];
